import React from 'react';

export const dateComponent = (pModule: string, pDate: string) => {
  const text = (pModule !== 'pluie' && pModule !== 'milieu') ? 'Données du ' : 'Données de ';
    return (
      pModule !== 'indus' &&
      pModule !== 'hydro' &&
      pDate !== '' && (
        <div style={{ display: 'inline-flex' }}>
          <span style={{ fontSize: 'smaller', alignSelf: 'center' }}>
            {text} : {pDate}
          </span>
        </div>
      )
    );
};